import { render, staticRenderFns } from "./WorkflowPrepTaskDetail.vue?vue&type=template&id=66b5d8ab"
import script from "./WorkflowPrepTaskDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports